<div class="modal fade" id="dialogAcao" tabindex="-1" role="dialog" aria-labelledby="Acao"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title">Ação de governo</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #f="ngForm" id="form_register" novalidate="">
        <input [(ngModel)]="entity.id" type="text" ngModel name="id" id="id" style="display: none">
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group col-2">
              <label for="codigo" class="col-form-label">Código<span class="text-danger">*</span></label>
              <input #codigoe autofocus [(ngModel)]="entity.codigo" type="text" ngModel name="codigo" maxlength="4"
                class="form-control form-control-sm" id="codigo">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <label for="nome" class="col-form-label">Nome da ação<span class="text-danger">*</span></label>
              <input [(ngModel)]="entity.nome" type="text" ngModel name="nome" class="form-control form-control-sm" maxlength="100"
                id="nome">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <label for="descricao" class="col-form-label">Descrição</label>
              <textarea [(ngModel)]="entity.descricao" ngModel name="descricao" class="form-control" id="descricao"
                rows="4"></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button [disabled]="!f.valid || !f.dirty" type="submit" (click)="salvarAcao(f.value)"
            class="btn btn-primary" id="btnSalvar">Salvar</button>
          <button #btnFecharAcao type="button" class="btn btn-link" id="btnCancelar"
            data-dismiss="modal">Cancelar</button>
        </div>
        <!-- <pre >{{ f.value | json}}</pre> -->
      </form>
    </div>
  </div>
</div>